import React, { useState } from "react";
import { LOGO_URL } from "../../config";
import "./Navbar.css";

const LINKS = [
  { id: "home",     label: "Home"     },
  { id: "episodes", label: "Episodes" },
  { id: "blog",     label: "Blog"     },
  { id: "guests",   label: "Guests"   },
  { id: "live",     label: "Live"     },
  { id: "about",    label: "About"    },
  { id: "contact",  label: "Contact"  },
];

export default function Navbar({ page, setPage, isLive, theme, toggleTheme }) {
  const [open, setOpen] = useState(false);

  const go = (id) => { setPage(id); setOpen(false); };

  return (
    <>
      <nav className="navbar">
        <div className="navbar-logo" onClick={() => go("home")}>
          <img src={LOGO_URL} alt="Talk News Logo" />
        </div>

        {/* Desktop links */}
        <ul className="navbar-links">
          {LINKS.map((l) => (
            <li key={l.id}>
              <button
                className={page === l.id ? "active" : ""}
                onClick={() => go(l.id)}
              >
                {l.label}
              </button>
            </li>
          ))}
        </ul>

        <div className="navbar-right">
          {isLive && (
            <button className="live-btn" onClick={() => go("live")}>
              <span className="live-dot" /> LIVE NOW
            </button>
          )}
          <button
            className="theme-btn"
            onClick={toggleTheme}
            title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
            aria-label="Toggle theme"
          >
            {theme === "dark" ? "☀️" : "🌙"}
          </button>
          {/* Hamburger — mobile only */}
          <button
            className="hamburger"
            onClick={() => setOpen((o) => !o)}
            aria-label={open ? "Close menu" : "Open menu"}
          >
            {open ? "✕" : "☰"}
          </button>
        </div>
      </nav>

      {/* Mobile drawer */}
      {open && (
        <div className="mobile-menu" onClick={() => setOpen(false)}>
          <div className="mobile-menu-inner" onClick={(e) => e.stopPropagation()}>
            {LINKS.map((l) => (
              <button
                key={l.id}
                className={`mobile-link ${page === l.id ? "active" : ""}`}
                onClick={() => go(l.id)}
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
